module.exports = __webpack_public_path__ + "static/media/ICON_chevronDown_Dark.cc8268e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/ICON_chevronDown_Dark.svg
// module id = 79
// module chunks = 0